import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import { LicenseInfo } from "@mui/x-license-pro";

LicenseInfo.setLicenseKey(
  "ec9905f2157897b2d6017ed597a6dfe9Tz01MjkwOSxFPTE2OTc5NzE0MDU1MDQsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
);
// Update: cambiar key por variable de entorno
// console.log(process.env.REACT_APP_LICENSE_MUIPRO)
// console.log(process.env.REACT_APP_URL_LOCAL)
// console.log(process.env.REACT_APP_URL_PRODUCTION)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
